import styled from "styled-components";
import { Link } from "react-router-dom";

export const HeaderSection = styled("header")<{ $scrolled: boolean }>`
  position: sticky;
  top: 0;
  z-index: 1000;
  background: var(--paper);
  border-bottom: 1px solid
    ${(p) => (p.$scrolled ? "var(--rule)" : "transparent")};
  transition: border-color 0.2s ease;
`;

export const HeaderNav = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  height: 76px;

  @media (max-width: 768px) {
    height: 64px;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  img {
    width: 138px;
    height: auto;
    display: block;
  }

  @media (max-width: 480px) {
    img { width: 116px; }
  }
`;

export const NavList = styled("nav")`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const NavItem = styled("button")`
  background: none;
  border: 0;
  padding: 0.25rem 0;
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--text);
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s ease, color 0.2s ease;

  &:hover {
    color: var(--ink);
    border-bottom-color: var(--ledger);
  }
`;

export const ContactLink = styled("button")`
  background: var(--ink);
  color: var(--on-ink);
  border: 1px solid var(--ink);
  border-radius: var(--radius);
  padding: 0.6rem 1.25rem;
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: var(--ink-2);
    color: #fff;
  }
`;

export const MobileRight = styled("div")`
  display: none;
  align-items: center;
  gap: 1rem;

  @media (max-width: 900px) {
    display: flex;
  }
`;

export const Burger = styled("button")`
  width: 44px;
  height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 6px;
  background: none;
  border: 0;
  padding: 0 4px;
  cursor: pointer;

  span {
    display: block;
    height: 1.5px;
    background: var(--ink);
  }
  span:first-child { width: 26px; }
  span:last-child { width: 18px; }
`;

export const DrawerHead = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.25rem;
  margin-bottom: 1.5rem;
  border-bottom: 3px double var(--rule);

  img { height: auto; }
`;

export const CloseButton = styled("button")`
  width: 44px;
  height: 44px;
  background: none;
  border: 0;
  font-size: 2rem;
  line-height: 1;
  color: var(--ink);
  cursor: pointer;
`;

export const DrawerNav = styled("nav")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;

  button:not(:last-child) {
    font-family: var(--font-display);
    font-size: 1.5rem;
    font-weight: 400;
  }

  button:last-child {
    margin-top: 1rem;
    width: 100%;
    padding: 0.875rem;
  }
`;
